/**
 * This hook allows you to check if the widget has resized.
 * You can update the widget if necessary (if has resized)
 *
 *
 * @example
 * To check if widget has been resized
 * ```
 *  let hasResized = useResizeEffect(props.instanceId);
 * ```
 * @export
 */
const useResizeEffect = (instanceId) => {
    let _resizedItems = window.resizedItems || [];
    let index = _resizedItems.indexOf(instanceId);
    if (index != -1) {
        // clear item
        _resizedItems.splice(index, 1);
        window.resizedItems = _resizedItems;
    }
    return (index != -1);
};
export default useResizeEffect;
